import React, { Component } from "react";
import AuthService from "services/auth.service";
import EBBanner from "assets/banners/home01x.svg";
import Account from "assets/icons/Account.svg";
import Bell from "assets/icons/Bell Icon.svg";
import { ProfileContent } from "./ProfileContent";
import { NavLink } from "react-router-dom";
import { Form } from "react-bootstrap";
import OnDemandService from "services/on-demand.service";

const ProfileBtn = (props) => {
  return (
    <span>
      <img
        src={Account}
        alt="account-btn"
        id="account-btn"
        className="banner-icon mr-20"
      />

      <div id="profile-popup" data-displayed={props.displayed}>
        <ProfileContent />
      </div>
    </span>
  );
};

export class DesktopNavbar extends Component {
  isDoctor =
    AuthService.getCurrentUser() &&
    AuthService.getCurrentUser().user_type !== "assistant";

  onDemandEnabled =
    this.isDoctor &&
    AuthService.getCurrentUser().is_bookdoc_nutritionist === false &&
    AuthService.getCurrentUser().teleconsult_on_demand?.enabled;
  constructor(props) {
    super(props);

    this.state = {
      onDemandStatus: this.onDemandStatus(),
    };
  }

  onDemandStatus() {
    OnDemandService.getStatus({
      doctor_id: AuthService.getCurrentUser()?.id,
    }).then(
      (data) => {
        this.setState({ onDemandStatus: data });
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace("/eb/login");
        }
      }
    );
  }
  setEnable = (checked) => {
    var params = {
      enable: checked,
    };

    OnDemandService.updateStatus(params).then(
      (data) => {
        console.log(params);
        this.setState({ onDemandStatus: data.status === "enabled" });
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace("/eb/login");
        }
      }
    );
  };

  render() {
    return (
      <div
        id="main-banner"
        className="d-lg-flex d-none align-items-center justify-content-end"
        style={{ backgroundImage: "url(" + EBBanner + ")" }}
      >
        {this.isDoctor}
        {/* Hide the bell icon for now, notifications come later. */}
        {this.isDoctor && (
          <>
            {this.onDemandEnabled && (
              <Form className="on-demand-form">
                <div className="d-flex">
                  <label htmlFor="on-demand-switch" className="label">
                    Enable On-Demand
                  </label>
                  <Form.Check
                    type="switch"
                    id="on-demand-switch"
                    className="switch-toggle"
                    defaultChecked={this.state?.onDemandStatus}
                    onClick={(e) => {
                      this.setEnable(e.target.checked);
                    }}
                  />
                </div>
              </Form>
            )}
            <NavLink
              end={true}
              to="/eb/notifications"
              className="text-white fweight-400"
            >
              <img
                src={Bell}
                alt="notification-btn"
                id="notification-btn"
                className="banner-icon mr-12"
              />
            </NavLink>
          </>
        )}

        <ProfileBtn displayed={this.props.dropdownDisplayed} />
      </div>
    );
  }
}
